import Joi from 'joi';
  
    
export const VALIDATION_RATING_CREATE = {
    options: {allowUnknownBody: false},
    body: {
      subjectId: Joi.string().required(),
      subjectType: Joi.string().required().valid('user', 'contractor', 'project'),
      objectId: Joi.string().required(),
      objectType: Joi.string().required(),
      content: Joi.string(),
      star: Joi.number().min(1).max(5).required(),
      // const RatingFields = {
      //   id: 'id',
      //   subjectId: 'subjectId',
      //   subjectType: 'subjectType',
      //   objectId: 'objectId',
      //   objectType: 'objectType',
      //   content: 'content',
      //   star: 'star',
      //   createdByUserId: 'createdByUserId',
      //   meta: 'meta',
      //   numberOfLikes: 'numberOfLikes',
      //   numberOfComments: 'numberOfComments',
      // };
      // meta: Joi.object().when(RatingFields.objectType, { is: CONTRACTOR, then:Joi.required() }),
    }
};
    
    
export const VALIDATION_RATING_UPDATE = {
    options: {allowUnknownBody: false},
    body: {
      id: Joi.string().required(),
      content: Joi.string(),
      star: Joi.number().min(1).max(5),
      meta: Joi.object(),
    }
};
    
    
export const VALIDATION_RATING_DELETE = {
    options: {allowUnknownBody: false},
    body: {
        id                                      : Joi.string().required(),
    }
};
    
    
export const VALIDATION_RATING_LIST = {
    options: {allowUnknownBody: false},
    body: {
        objectId                                : Joi.string().required(),
        page: Joi.number()
    }
};



// WEBPACK FOOTER //
// ./src/services/rating/Rating.Validator.js